module.exports = __webpack_public_path__ + "img/bonus-valentine.4d2c0b08.png";